export default __webpack_public_path__ + "static/media/logo_azot.baa3d4ed.png";